var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSynturaLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 40,
    viewBox: "0 0 195 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Syntura_logo 1",
    clipPath: "url(#clip0_2706_1845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYNTURA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.2686 23.1658H54.4184C54.5238 25.5191 57.2117 26.7497 59.9268 26.7497C62.1716 26.7497 64.9121 25.9136 64.9121 24.1335C64.9121 19.843 50.8151 22.3552 50.8151 15.633C50.8151 12.3376 54.4438 10.4279 59.4037 10.4279C64.6505 10.4279 68.3827 12.6516 68.5135 16.5476H64.4144C64.2836 14.2983 61.8553 13.1737 59.351 13.1737C57.1062 13.1737 54.8615 13.8803 54.8615 15.4485C54.8615 19.4759 69.0619 17.0697 69.0619 24.0275C69.0619 27.5584 64.9375 29.5721 59.8468 29.5721C54.4945 29.5721 50.3193 27.2188 50.2666 23.1639L50.2686 23.1658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.4001 10.8204V10.7164H72.8896L76.3095 15.9745L78.033 18.8518H78.3727L80.0962 15.9745L83.5161 10.7164H88.0055V10.8204L80.1743 21.9627V29.2856H76.2333V21.9882L68.4021 10.8204H68.4001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M91.4605 10.7164H96.4458L102.475 22.0157L104.355 25.8076H105.452V10.7164H109.159V29.2875H102.241L96.2623 17.9882L94.3826 14.1963H93.2856V29.2875H89.5535V12.6006C89.5535 11.5015 90.3635 10.7183 91.4586 10.7183L91.4605 10.7164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M118.419 13.6977H111.109V10.7164H129.696V13.6977H122.36V29.2856H118.419V13.6977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M131.636 22.1982V10.7164H135.577V22.3042C135.577 25.4171 138.214 26.6202 141.007 26.6202C143.8 26.6202 146.437 25.4171 146.437 22.3042V10.7164H150.378V22.1982C150.378 25.4681 148.081 29.5741 141.007 29.5741C133.933 29.5741 131.636 25.4681 131.636 22.1982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M154.864 10.7164H163.138C167.68 10.7164 170.448 12.7831 170.448 16.2865C170.448 18.9813 168.725 20.9166 165.644 21.5701L167.159 23.4799L171.596 29.2856H166.898L161.495 21.8312H156.874V29.2856H152.933V12.5986C152.933 11.4995 153.743 10.7164 154.866 10.7164H154.864ZM163.087 19.0598C165.307 19.0598 166.298 17.9882 166.298 16.261C166.298 14.5338 165.045 13.5662 162.773 13.5662H156.874V19.0598H163.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M180.016 10.7164H186.622L195.002 29.2875H190.694L188.265 23.6899H178.293L175.865 29.2875H171.635L180.014 10.7164H180.016ZM187.038 20.8655L185.341 16.9421L183.905 13.4897H182.677L181.24 16.9421L179.544 20.8655H187.036H187.038Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.875 28.21C25.875 28.8008 26.1092 29.3366 26.486 29.7311H26.484L32.3242 35.6055L35.4083 32.5044L29.6188 26.685C29.6032 26.6693 29.5876 26.6536 29.572 26.6379L29.5661 26.632C29.1738 26.2512 28.6409 26.0177 28.0534 26.0177C26.849 26.0177 25.873 26.999 25.873 28.21H25.875Z",
    fill: "url(#paint0_linear_2706_1845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.9191 11.7978C13.9191 11.2071 13.6848 10.6712 13.3062 10.2767H13.3081L7.46787 4.40234L4.38379 7.50342L10.1733 13.3248C10.1889 13.3405 10.2026 13.3562 10.2182 13.37L10.224 13.3758C10.6164 13.7566 11.1493 13.9902 11.7368 13.9902C12.9411 13.9902 13.9171 13.0088 13.9171 11.7978H13.9191Z",
    fill: "url(#paint1_linear_2706_1845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M28.0553 13.9725C28.6429 13.9725 29.1757 13.737 29.5681 13.3582H29.57L35.4103 7.48774L32.3262 4.38666L26.5387 10.2081C26.523 10.2238 26.5074 10.2395 26.4918 10.2552L26.486 10.261C26.1073 10.6555 25.873 11.1914 25.873 11.7821C25.873 12.9931 26.849 13.9745 28.0534 13.9745L28.0553 13.9725Z",
    fill: "url(#paint2_linear_2706_1845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.7329 26.0157C11.1453 26.0157 10.6125 26.2512 10.2201 26.632H10.2182L4.37793 32.5025L7.46201 35.6035L13.2515 29.7822C13.2671 29.7665 13.2827 29.7527 13.2964 29.737L13.3023 29.7311C13.6809 29.3366 13.9152 28.8008 13.9152 28.21C13.9152 26.999 12.9392 26.0177 11.7348 26.0177L11.7329 26.0157Z",
    fill: "url(#paint3_linear_2706_1845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.714 0V12.0393C17.714 15.2188 15.1413 17.8037 11.9811 17.8037H0V22.1766H11.9811C14.6748 22.1766 17.2065 21.1227 19.1116 19.2071C21.0167 17.2915 22.0649 14.7458 22.0649 12.0373V0",
    fill: "url(#paint4_linear_2706_1845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M22.0648 40V27.949C22.0648 24.7694 24.6374 22.1825 27.7996 22.1825H39.7826V17.8076H27.7996C25.1059 17.8076 22.5742 18.8616 20.6691 20.7772C18.764 22.6928 17.7158 25.2385 17.7158 27.947V39.998",
    fill: "url(#paint5_linear_2706_1845)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2706_1845",
    x1: -0.566137,
    y1: 30.8106,
    x2: 35.1038,
    y2: 30.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2706_1845",
    x1: 4.61217,
    y1: 9.19724,
    x2: 40.2802,
    y2: 9.19724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2706_1845",
    x1: -11.9851,
    y1: 9.17959,
    x2: 73.0771,
    y2: 9.17959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2706_1845",
    x1: -33.4704,
    y1: 30.8087,
    x2: 51.5917,
    y2: 30.8087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2706_1845",
    x1: -5.83438,
    y1: 11.0893,
    x2: 53.7099,
    y2: 11.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2706_1845",
    x1: -13.857,
    y1: 28.9048,
    x2: 45.4531,
    y2: 28.9048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706_1845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynturaLogoWhite);
export default __webpack_public_path__ + "static/media/Syntura_logo_white.4fba408f5532187c6be5c810fa5d0c94.svg";
export { ForwardRef as ReactComponent };